import React from 'react';
import EventCard from '../../../shared/EventCard/EventCard';
import EmptyState from './EmptyState';

// Flat, date-sorted list (events arrive already sorted/filtered) — no grouping.
const Agenda = ({ events, onOpen, onClear }) => {
    if (!events.length) {
        return (
            <main className="agenda">
                <EmptyState onClear={onClear} />
            </main>
        );
    }

    return (
        <main className="agenda">
            {events.map((ev) => (
                <EventCard key={ev.id} event={ev} onActivate={onOpen} />
            ))}
        </main>
    );
};

export default Agenda;
